import { cn } from "@/lib/cn";
import { useTheme } from "@/state/ThemeProvider";

/** Sun/moon switch between the bright and dark themes. */
export function ThemeToggle({ className, withLabel = false }: { className?: string; withLabel?: boolean }) {
  const { theme, toggle } = useTheme();
  const next = theme === "light" ? "dark" : "bright";
  return (
    <button
      type="button"
      className={cn("theme-toggle", withLabel && "theme-toggle--labelled", className)}
      onClick={toggle}
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
    >
      <span className={cn("theme-toggle__track", theme === "light" && "is-light")} aria-hidden>
        <svg viewBox="0 0 24 24" className="theme-toggle__sun" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4" />
        </svg>
        <svg viewBox="0 0 24 24" className="theme-toggle__moon" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19.5 14.5A8 8 0 0 1 9.5 4.5a8 8 0 1 0 10 10z" />
        </svg>
      </span>
      {withLabel ? <span className="theme-toggle__label">{theme === "light" ? "Bright theme" : "Dark theme"}</span> : null}
    </button>
  );
}
